import React, {useEffect, useState} from 'react';
import './SetItem.css';
import {eventEmitter, lang} from '../../../common/baseData';

function SetItem(props) {
  const {productSet, messages, inBasket, onAddToBasket} = props;
  const setKey = productSet.ROOT_SET.ID

  const products = productSet.PRODUCTS.map((product, productIndex) => {
    let oldPriceExists = !!product.OLD_PRICE_FORMATED;
    let productKey = product.ID

    return <>
      <div className="product" key={`${setKey}-${productKey}`}>
        <img
            src={product.IMAGE_150_SRC}
            alt={product.NAME}
            title={product.NAME}
            width={'120px'}
            height={'120px'}
            onClick={event => {
              window.location.href = product.URL;
            }}
        />
        <div className="product-details">
          <div className="name">
            <a href={product.URL}
               className="product-link">
              {product.NAME}
            </a>
            <div className="code">
              {product.ARTICLE}
            </div>
          </div>
          <div className="price">
            <span className="current-price">
                              {product.PRICE_FORMATED}
                            </span>
          </div>
        </div>
      </div>
      {
          productIndex !== productSet.PRODUCTS.length -
          1 &&
          (
              <div className="add-to-cart">
                <span>+</span>
              </div>
          )
      }
    </>
  })

  return (
      <>
        <div className={`set-products`}>
          {products}
        </div>
        <div className="set-total">
          <div className="prices">
            <div className="set-sale">
              {messages.SALE} {productSet.ROOT_SET.SALE}
            </div>
            <div className="set-price">
              {productSet.ROOT_SET.PRICE_FORMATED}
            </div>
          </div>
          <div className="buy-set"
               onClick={() => {
                 if (!inBasket(setKey)) onAddToBasket(setKey);
                 else eventEmitter.emit('openSmallCart');
               }}>
            <i className="icon-basket_white"></i>
            <span>
              {inBasket(setKey) ? messages.IN_BASKET : messages.BUY}
            </span>
          </div>
        </div>
      </>
  );
}

export default SetItem;
